

import React, { useEffect, useState } from 'react';
import './Profil.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog } from '@fortawesome/free-solid-svg-icons';
import GetProCard from '../rightelements/GetProCard';
import FooterElements from '../rightelements/FooterElements';
import SocialElements from '../rightelements/SocialElements';
import './reglaredimensiune.css';


const badges = [
  { name: 'Basic Profile', desc: 'Added bio to profile', progress: 0, total: 3 },
  { name: 'The Start', desc: 'Solved 3 coding problems', progress: 0, total: 5 },
  { name: 'Daily Coder', desc: 'Maintained a 3-day streak', progress: 0, total: 5 },
  { name: 'Basic Profile', desc: 'Added bio to profile', progress: 0, total: 3 },
  { name: 'The Start', desc: 'Solved 3 coding problems', progress: 0, total: 5 },
  { name: 'Daily Coder', desc: 'Maintained a 3-day streak', progress: 0, total: 5 },
  { name: 'Basic Profile', desc: 'Added bio to profile', progress: 0, total: 3 },
  { name: 'The Start', desc: 'Solved 3 coding problems', progress: 0, total: 5 },
  { name: 'Daily Coder', desc: 'Maintained a 3-day streak', progress: 0, total: 5 },
];

const apiUrl = process.env.REACT_APP_API_URL;

const Profil = ({ onMenuSelect, onCogClick }) => {
  const [userData, setUserData] = useState(null);
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await fetch(`${apiUrl}/user`, { credentials: 'include' });
        const user = await res.json();
        setUserData(user);
      } catch (err) {
        setUserData(null);
      }
    };
    fetchUser();
  }, []);

  return (

    <div className="componentsmenu-container-main">
      <div className="componentsmenu-left-blank"></div>
      <div className="profil-container">
      {/* Bara de sus cu Profile stanga si rotita dreapta */}
      <div className="profil-header-bar">
        <span className="profil-header-title">Profil</span>
        <span className="profil-header-cog" onClick={() => { if (onCogClick) { onCogClick(); } else if (onMenuSelect) { onMenuSelect('Setari'); } }} style={{cursor:'pointer'}}><FontAwesomeIcon icon={faCog} /></span>
      </div>
    

      {/* ...restul codului existent... */}
    <div className="profil-banner">
    

    <div className="profil-avatar-wrapper">
      <div className="profil-avatar-placeholder">
        {userData?.profile_picture ? (
          <img src={userData.profile_picture} alt="user" className="profil-avatar-img" />
        ) : (
          <span className="profil-avatar-plus">+</span>
        )}
      </div>
    </div>

    

    <div className="profil-level-box">
      <div className="profil-level-text">
        Nivel 1 • Incepator
      </div>
      <div className="profil-xp-text">
        120 / 500 XP
      </div>
      <div className="profil-xp-bar">
        <div className="profil-xp-fill" style={{ width: "24%" }}></div>
      </div>
    </div>

    
    <div className='align-user-buttons'>
      <div className='standard-section'>
        <div className="profil-current-label">
            Cont curent:
        </div>
        <div className="profil-account-badge standard">
          <span className='color-button-standard'>STANDARD</span>
        </div>
      </div>
      
      <button className="profil-premium-btn">
        <span className='color-button-premium'>Incearca PREMIUM</span>
      </button>
    </div>

    
  </div>

      <div className="profil-main">

        <div className='user-stats-elements-secondsection'>
          <h2 className="profil-username">alindorobantu95</h2>
          <a href="#" className="profil-add-username">Editeaza username</a>
          <div className="profil-follow-info">
            <span>0 Following</span>
            <span>0 Followers</span>
          </div>
          <div className="profil-stats">
            <div className="profil-stat">
              <span className="profil-stat-value">0</span>
              <span className="profil-stat-label">Streak</span>
            </div>
            <div className="profil-stat">
              <span className="profil-stat-value profil-xp">0</span>
              <span className="profil-stat-label">Total XP</span>
            </div>
            <div className="profil-stat">
              <span className="profil-stat-value profil-league">-</span>
              <span className="profil-stat-label">Current league</span>
            </div>
          </div>
        </div>
{/*

        <div className="profil-badges-box">
          <h3>Medalii</h3>
          <div className="profil-badges-list">
            {badges.map((badge, idx) => (
              <div className="profil-badge" key={idx}>
                <div className="profil-badge-icon">?</div>
                <div className="profil-badge-info">
                  <div className="profil-badge-title">{badge.name}</div>
                  <div className="profil-badge-desc">{badge.desc}</div>
                </div>
                <div className="profil-badge-progress">{badge.progress}/{badge.total}</div>
              </div>
            ))}
          </div>
        </div>
        */}
      </div>
 

      </div>
      <div className="right-elements-componentsmenu-profil">
        <GetProCard />
           <FooterElements />
      <SocialElements />
      </div>
    </div>



  );
}

export default Profil;
